// ProductsList.jsx
import React from 'react';
import KitchenReferenceList from './KitchenReferenceList';

const ProductsList = (props) => {
  return <KitchenReferenceList referenceType="products" {...props} />;
};

export default ProductsList;